export default {
  title01: "Vremea actuală",
  title02: "24 de ore",
  title03: "Vedeți prognoza meteo pe 10 zile",
  title04: "Indexul calității aerului",
  title05: "Vezi toate informațiile",
  title06: "RĂSĂRIT ȘI APUS DE SOARE",
  title07: "FAZA LUNII",
  title08: "Următoarea lună plină",
  title09: "Următoarea lună nouă",
  title10: "ZI",
  title11: "NOAPTE",
  title12: "Răsărit",
  title13: "Apus de soare",
  title14: "Răsărit de lună",
  title15: "Apus de Lună",
  title16: "Sursa",
  title17: "Începe",
  title18: "Sfârșit",
  title19: "Utilizați locația curentă",
  title20: "Căutați orașul",
  title21: "Se simte ca",
  title22: "Resimțit la umbră",
  title23: "Acum",
  title24: "Astăzi",
  title25: "DUM",
  title26: "LUN",
  title27: "MAR",
  title28: "MIE",
  title29: "JOI",
  title30: "VIN",
  title31: "SMB",
  title32: "Se încarcă...",
  title33: "Acum",
  title34: "Ore",
  title35: "Zilnic",
  title36: "Soare și lună",
  title37: "Calitatea aerului",
  title38: "Contact la: xlf550402@gmail.com",
  title39: "Acord de confidențialitate",
  title40: "Drepturi de autor © comfortweather.com 2020 - 2025. Toate drepturile rezervate.",
  title41: "Date furnizate de",
  title42: "Hi",
  title43: "Lo",
  title44: "Accept",
  title45:
    "Mulțumim că folosiți ComfortWeather! Pentru a vă proteja mai bine drepturile și interesele legale, vă rugăm să citiți cu atenție ",
  title46: "Politica de Confidențialitate",
  title47: " înainte de utilizare.",
  title48: "",
  title49: "Contact la: xyjph123@gmail.com",
  title50: "Drepturi de autor © 24hweather.com 2020 - 2025. Toate drepturile rezervate.",
  title51:
    "Mulțumim că folosiți 24hweather! Pentru a vă proteja mai bine drepturile și interesele legale, vă rugăm să citiți cu atenție ",
};
